import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.nav`
	padding: 0 16px;
	margin: 0;
	max-width: 320px;
	width: 100%;
	min-width: 200px;
	position: sticky;
	top: 46px;
	height: fit-content;
	border-left: 1px solid ${helpers.color.border};
	font-size: ${helpers.font.size.small};

	@media only screen and (max-width: 1250px) {
		display: none;
		position: relative;
		padding: 0 32px;
		max-width: unset;
		min-width: unset;
	}
`
